import React from 'react';
import SignupSection from '../../prelogin/src/components/SignupSection';
import UserLoginType from './za_UserLoginType';

export default class za_SignupSection extends SignupSection{
	render() {
		const styles={
			display:'inline-block',
			fontWeight:500
		}
  	return(
	<section data-p-ga="" className="mtb child">
		<div className="container">
			 <h2>{this.rb("signup.section.txt.1")}</h2>
			 <h2><span className="hmorg" style={styles}>Hey</span><span className="hmblue" style={styles}>Math!&nbsp;</span>{this.rb("signup.section.txt.2")}</h2>
			 {(() => {
				if(!this.props.PLPloggedIn){
					return(
							<div className="col-sm-5 mx-auto text-center">
								<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Bottom"}/>
							</div>
					);
				}
			})()}
			 
			 
		</div>
	</section> 
  	);
  }


}


// WEBPACK FOOTER //
// ./src/views/za/za_SignupSection.js